<template>
    <router-link :to="to" class="uni-cta-link uni-button">
        <slot/>
    </router-link>
</template>

<script>
    export default {
        name: "UniCtaLink",
        props: {
            to: {
                type:[Object, String],
                default: function() {
                    return {name: 'home'}
                },
            }
        }
    }
</script>

<style scoped lang="scss">


    .uni-cta-link {
        border-radius: var(--radius-default);
        padding: var(--s-xs) var(--s-m);
        background: var(--color-primary);
        color: white;
        width: 100%;
        text-align: center;
        height: 48px;
        line-height: 28px;
        margin-bottom: 16px;

        &.uni-cta-link--small {
            height: 32px;
            line-height: 14px;
        }
        &.uni-cta-link--extra-small {
            padding: 0 8px;
            height: 32px;
        }

        &.uni-cta-link--secondary {
            background: var(--color-primary-light-2);
            color: var(--color-primary);
        }
    }

    @media screen-m{
        .uni-cta-link{
            display:initial;
        }
    }

</style>
